import React, { useState } from "react";


import * as Constants from '../../utils/constants';
import { validateEmail, validateName, getTodayDate } from '../../utils/validation';

import '../../assets/css/form.css';

import CompetitorRepository from '../../domain/repositories/CompetitorRepository';
import Competitor from '../../domain/models/CompetitorModel';




function AddCompetitor() {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [dob, setDob] = useState("");
  const [email, setEmail] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  const competitorRepository = new CompetitorRepository();


  const handleFormSubmit = async (event) => {
    event.preventDefault();
    setIsSubmitting(true);
    setError("");
    setSuccess("")

    try {

      const errors = [];

      if (!validateName(firstName)) {
        errors.push(Constants.FIRST_NAME_ERROR);
      }
      else if (!validateName(lastName)) {
        errors.push(Constants.LAST_NAME_ERROR);
      }
      else if (!validateEmail(email)) {
        errors.push(Constants.VALID_EMAIL_ERROR);

      }

      if (errors.length > 0) {
        setError(errors);
        setIsSubmitting(false);
      } else {
        // submit form data

        var add_competitor_url = Constants.API_ENDPOINT + Constants.ENDPOINT_ITEMS_COMPETITOR
        var post_request = JSON.stringify(
          {
            'status': Constants.PUBLISHED,
            'competitor_first_name': firstName,
            'competitor_last_name': lastName,
            'competitor_email': email,
            'competitor_dob': dob.trim() === "" ? null : dob
          })
        console.log(post_request)
        const competitorModel=new Competitor()
        competitorModel.competitorDob=dob.trim() === "" ? null : dob



        async function createCompetitor() {
          try {

            // const competitor = await participatesInRepository.getParticipatesInById('e0555655-b56e-427f-af17-cb1cf70dcb76');

            let participates = await competitorRepository.createCompetitor(competitorModel)

            console.log("Particiaptes Data", participates)
          } catch (error) {
            console.error("Particiaptes Data Error:", error);
          }
        }

        createCompetitor()

        const response = await fetch(add_competitor_url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Constants.TOKEN}`

          },
          body: post_request,
        });

        if (response.ok) {
          const data = await response.json();
          console.log(data)
          setIsSubmitting(false);
          setSuccess(Constants.SUCCESSFULLY_ADDED)
          setFirstName('');
          setLastName('')
          setDob('');
          setEmail('')
        } else {
          setError(Constants.SOMETHING_WENT_WRONG);
          setIsSubmitting(false);
        }
      }
    } catch (error) {
      console.error(error);
      setIsSubmitting(true);
      setError(Constants.SOMETHING_WENT_WRONG);
    }
  };


  return (
    <div>
      <h2>Add a Competitor</h2>

      <form className="form-container" onSubmit={handleFormSubmit}>
        <div className="form-group">
          <label>
            First Name
            <input type="text" value={firstName} onChange={(e) => setFirstName(e.target.value)} />
          </label>
        </div>

        <div className="form-group">
          <label>
            Last Name
            <input type="text" value={lastName} onChange={(e) => setLastName(e.target.value)} />
          </label>
        </div>

        <div className="form-group">
          <label>
            Email
            <input type="text" value={email} onChange={(e) => setEmail(e.target.value)} />
          </label>
        </div>

        <div className="form-group">
          <label>
            Date of Birth
            <input type="date" max={getTodayDate()} value={dob} onChange={(e) => setDob(e.target.value)} />
          </label>
        </div>
        <div className="form-group">

          <button type="submit" disabled={isSubmitting}>
            {isSubmitting ? 'Please wait...' : 'Add'}
          </button>

        </div>
        {isSubmitting && <div className="spinner"></div>}


        {error && <p className="error-message ">{error}</p>}
        {success && <p className="success-message ">{success}</p>}


      </form>
    </div>
  );
}

export default AddCompetitor;
